module.exports = __webpack_public_path__ + "img/pdf_bg_intereses_nuevo.4924780b.png";